(function () {
    window._ = require('lodash');

    /**
     * We'll load jQuery and the Bootstrap jQuery plugin which provides support
     * for JavaScript based Bootstrap features such as modals and tabs. This
     * code may be modified to fit the specific needs of your application.
     */

    try {
        window.bootstrapDatepickerConfig = {
            dateFormat: 'dd-mm-yy',
            firstDay: 1,
            ignoreReadonly: true,
            orientation: 'right bottom',
            forceParse: false,
            format: {
                /*
                 * Say our UI should display a week ahead,
                 * but textbox should store the actual date.
                 * This is useful if we need UI to select local dates,
                 * but store in UTC
                 */
                toDisplay: function (date, format, language) {
                    return moment(date).format('DD-MM-YYYY');
                },
                toValue: function (date, format, language) {
                    return moment(date).format('YYYY-MM-DD');
                }
            }
        }


        window.$ = window.jQuery = require('jquery')
        require('jquery-ui/ui/effect');
        window.tinymce = require("tinymce/tinymce");
        window.autosize = require('autosize');
        window.moment = require('moment');

        $(() => {
            require('@noardcode/compass-core/resources/js/components/confirm');
            require("@noardcode/compass-side-panels")
            require("@noardcode/compass-crm")
            require("@noardcode/compass-financial")
        })

        require('tinymce/models/dom');
        require('tinymce/themes/silver');
        require('tinymce/plugins/table');
        require('tinymce/plugins/lists');
        require('tinymce/plugins/link');
        require('tinymce/plugins/autolink');
        require('tinymce/plugins/wordcount');

        require("bootstrap");
        require("jquery-ui/ui/widgets/datepicker");
        require("bootstrap-select/dist/js/bootstrap-select.min");
        require("bootstrap-select/dist/js/i18n/defaults-nl_NL.min");

        require("./year-select-component");
        require("./tools/resizeTextarea");
        require("./../../shared/js/hide-tooltips");
        require("./../../shared/js/scrolling");

        require('./includes/cancellation-reasons');
    } catch (e) {
        console.log(e)
    }

    window.Cropper = require('cropperjs');

    /**
     * Next we will load all of this project's JavaScript dependencies.
     * It is a great starting point when building robust, powerful web applications.
     */

    $(document).ready(function () {
        /**
         * Ajax CSRF TOKEN Header
         */
        $.ajaxSetup({
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        });

        $('[data-toggle="tooltip"]').tooltip({
            html: true
        })

        $('[data-toggle="popover"]').popover({
            html: true,
            sanitize: false,
            trigger: 'focus hover'
        });

        /**
         * TinyMCE
         */
        tinymce.baseURL = '/vendor/tinymce';
        tinymce.init({
            relative_urls: false,
            remove_script_host: false,
            selector: '.text-editor, .text-editor-with-anchor',
            height: 450,
            plugins: 'autolink table lists wordcount link',
            paste_as_text: true,
            toolbar: 'formatselect | bold italic strikethrough | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent | removeformat | link',
            setup: function (editor) {
                editor.on('change', function () {
                    tinymce.triggerSave();
                });
            }
        });

        $.datepicker.regional['nl'] = {
            clearText: 'Effacer', clearStatus: '',
            closeText: 'sluiten', closeStatus: 'Onveranderd sluiten ',
            prevText: '<vorige', prevStatus: 'Zie de vorige maand',
            nextText: 'volgende>', nextStatus: 'Zie de volgende maand',
            currentText: 'Huidige', currentStatus: 'Bekijk de huidige maand',
            monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
                'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
            monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
                'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
            monthStatus: 'Bekijk een andere maand', yearStatus: 'Bekijk nog een jaar',
            weekHeader: 'Sm', weekStatus: '',
            dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
            dayNamesShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
            dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
            dayStatus: 'Gebruik DD als de eerste dag van de week', dateStatus: 'Kies DD, MM d',
            dateFormat: 'dd/mm/yy', firstDay: 1,
            initStatus: 'Kies een datum', isRTL: false
        };

        /**
         * Datepicker Jquery UI
         */
        $('.datepicker').datepicker({
            dateFormat: 'dd-mm-yy',
            firstDay: 1,
            ignoreReadonly: true,
            beforeShow: function (input, datepicker) {
                var datepickerTop = $(input).offset().top + parseInt($(input).outerHeight()) - $(document).scrollTop();
                setTimeout(function () {
                    datepicker.dpDiv.css({
                        top: datepickerTop
                    });
                }, 0);
            }
        });

        /**
         * Auto select end dates on select of start date.
         */
        $('.datepicker[name*=start]').on('change', function (e) {
            var endTime = $(this).parent().parent().parent().find('.datepicker[name*=end]');

            if (endTime.val() === "") {
                endTime.val($(this).val());
            }
        });

        /**
         * Auto select end dates on select of start date.
         */
        $('.datepicker[name*=end]').on('change', function (e) {
            var startTime = $(this).parent().parent().parent().find('.datepicker[name*=start]');

            if (startTime.val() === "") {
                startTime.val($(this).val());
            }
        });

        /**
         * Update value with group btn (used in tables)
         */
        $(".btn-group.ajax-update > .btn").click(function () {
            var clicked = $(this);
            clicked.addClass("active").siblings().removeClass("active");

            $.ajax({
                method: "PUT",
                url: clicked.parent().attr('data-update-url'),
                data: {'type': clicked.attr('data-name')}
            });
        });

        /**
         * Show file name(s) after selecting using a custom file input field
         */
        $('.custom-file-input').on('change', function (event) {
            var files = [];

            $.each(event.target.files, function (index, value) {
                files.push(value.name)
            });

            $(this).next('.custom-file-label').addClass("selected").html(files.join(', '));
        });

        /**
         * Copy multiple presets (Vacations and Holidays)
         */
        $('.copy-multiple').on('submit', function () {
            try {
                var inputName = $(this).attr('data-input-name');

                var ids = $('input[name="' + inputName + '[]"]').serializeArray();

                ids = $.map(ids, function (item) {
                    return item.value;
                });

                $(this).find('input[name="ids"]').val(ids.join(','));
            } catch (e) {
                return false;
            }

            return true;
        });

        /**
         * Cropper js
         */
        var $container = $('.cropperjs-container');
        var $image = $container.find('img');
        if ($image.length > 0) {
            new Cropper(document.getElementById($image.attr('id')), {
                aspectRatio: parseFloat($image.attr('data-aspect-ratio')),
                viewMode: 1,
                data: {
                    x: parseInt($image.attr('data-cropbox_x')),
                    y: parseInt($image.attr('data-cropbox_y')),
                    width: parseInt($image.attr('data-cropbox_width')),
                    height: parseInt($image.attr('data-cropbox_height')),
                    rotate: 0,
                    scaleX: 1,
                    scaleY: 1
                },
                crop: function (e) {
                    e = e.detail;
                    $container.find('input[name=cropped_x]').val(e.x);
                    $container.find('input[name=cropped_y]').val(e.y);
                    $container.find('input[name=cropped_width]').val(e.width);
                    $container.find('input[name=cropped_height]').val(e.height);
                }
            });
        }

        // Bootstrap select
        $('.selectpicker').selectpicker();

        // // Bootstrap multi-select
        // $('.multiselectpicker').selectpicker();

        if ($('#faq').length) {
            require('./faq');
        }

        if ($('.chat-container').length || $('#chat-overview-container').length) {
            require('../../shared/js/chat');
        }

        if ($('#booking-details-container').length) {
            require('./plugins/bookings/show');
        }

        if ($('.stateFormContainer').length) {
            require('./plugins/bookings/update-state');
        }

        $('.custom-file-input').change((e) => {
            let text = '';

            for (let k in e.target.files) {
                if (e.target.files.hasOwnProperty(k)) {
                    if (text.length === 0)
                        text = e.target.files[k].name
                    else
                        text = text + ', ' + e.target.files[k].name
                }
            }

            if (text.length === 0)
                $(e.target).siblings('label').text('Choose file')
            else {
                $(e.target).siblings('label').text(text)
            }
        });

        jQuery.fn.getFormDataAssociative = function () {
            let fd = new FormData();
            let f = this.serializeArray();
            for (let k in f) {
                if (f.hasOwnProperty(k)) {
                    fd.append(f[k].name, f[k].value);
                }
            }

            this.find('input[type="file"]').each((k, v) => {
                for (let fk in v.files) {
                    if (v.files.hasOwnProperty(fk))
                        fd.append($(v).attr('name'), v.files[fk] ?? '');
                }
            });

            return fd;
        }

        jQuery.fn.fillFormErrors = function (err) {
            let f = $(this[0]);
            for (let k in err) {
                if (err.hasOwnProperty(k)) {
                    f.find('[name="' + k + '"]').addClass('is-invalid')
                        .closest('.form-group')
                        .find('.invalid-feedback')
                        .addClass('d-block')
                        .text(err[k]);
                }
            }
        }

        $('.login-popup-modal').modal({keyboard: false, backdrop: 'static'});

        window.timeouts = [];

        $(document).on('click', '.disable-after-click', function (e) {
            $(this).html($(this).text() + '<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>')
            window.timeouts.push(setTimeout(() => {
                $(this).prop('disabled', true);
                $(this).css('cursor', 'unset');
            }));
        });

        $("form select, form input, form textarea").on("invalid", function (event) {
            let form = $(this).closest("form");
            let btn = form.find('.disable-after-click');

            if (btn.length !== 0) {
                for (var i = 0; i < window.timeouts.length; i++) {
                    clearTimeout(window.timeouts[i]);
                }

                btn.prop('disabled', false);
                btn.css('cursor', 'pointer');
                btn.html(btn.html().replace('<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>', ''));
            }
        });
    });

    // setTimeout(() => {
    //     $('.modal #reason, #reason').each(function () {
    //         let element = $(this);
    //
    //         let infoBlockPeriodAvailable = $('#tip-other-period-available', element.parent().parent());
    //         let infoBlockDoubleBooked = $('#tip-double-booked', element.parent().parent());
    //         let infoBlockCalendarNotCurrent = $('#tip-calendar-not-current', element.parent().parent());
    //         let infoBlockIncorrectAudience = $('#tip-incorrect-audience', element.parent().parent());
    //         let infoBlockCancelledByGuest = $('#cancelled_by_guest', element.parent().parent());
    //
    //         if (element.val() === 'other_converted') {
    //             infoBlockPeriodAvailable.show();
    //         } else {
    //             infoBlockPeriodAvailable.hide();
    //         }
    //
    //         if (element.val() === 'double_booked') {
    //             infoBlockDoubleBooked.show();
    //         } else {
    //             infoBlockDoubleBooked.hide();
    //         }
    //
    //         if (element.val() === 'calendar_not_current') {
    //             infoBlockCalendarNotCurrent.show();
    //         } else {
    //             infoBlockCalendarNotCurrent.hide();
    //         }
    //
    //         if (element.val() === 'incorrect_audience') {
    //             infoBlockIncorrectAudience.show();
    //         } else {
    //             infoBlockIncorrectAudience.hide();
    //         }
    //
    //         if (element.val() === 'cancelled_by_guest') {
    //             infoBlockCancelledByGuest.show();
    //         } else {
    //             infoBlockCancelledByGuest.hide();
    //         }
    //
    //         element.on('change', function () {
    //             if (element.val() === 'other_converted') {
    //                 infoBlockPeriodAvailable.show(500);
    //             } else {
    //                 infoBlockPeriodAvailable.hide();
    //             }
    //             if (element.val() === 'double_booked') {
    //                 infoBlockDoubleBooked.show(500);
    //             } else {
    //                 infoBlockDoubleBooked.hide();
    //             }
    //             if (element.val() === 'calendar_not_current') {
    //                 infoBlockCalendarNotCurrent.show(500);
    //             } else {
    //                 infoBlockCalendarNotCurrent.hide();
    //             }
    //             if (element.val() === 'incorrect_audience') {
    //                 infoBlockIncorrectAudience.show(500);
    //             } else {
    //                 infoBlockIncorrectAudience.hide();
    //             }
    //
    //             if (element.val() === 'cancelled_by_guest') {
    //                 infoBlockCancelledByGuest.show();
    //             } else {
    //                 infoBlockCancelledByGuest.hide();
    //             }
    //         });
    //     });
    // }, 200);

    setTimeout(() => {
        $('#prices-wrapper li a.nav-link').each(function () {
            if (window.location.hash == '#' + $(this).attr('id')) {
                $(this).click();
            }
            $(this).on('keydown click', function () {
                let url = window.location.pathname + '#' + $(this).attr('id');
                history.replaceState({}, '', url);
            });
        });
    }, 200);
})();
